import type File from '../../../interfaces/File';
import { getFileTitle } from '../../../utils/utils';

/**
 * Client-side name filter for folder-picker lists.
 * `getFiles` accepts `search`, but `/myfiles/v2` often returns the unfiltered page
 * (main-app search uses `/myfiles/search` + `keyword` instead). Filter locally so
 * the toolbar still narrows the current destination list.
 */
export function filterPickerFilesBySearch<T extends File>(
  files: T[],
  search: string | undefined,
): T[] {
  const q = search?.trim().toLowerCase();
  if (!q) return files;
  return files.filter((f) => getFileTitle(f).toLowerCase().includes(q));
}
